<template>
	<div class="account__section">
		<h3 class="account__section__title">{{$t('account.network')}}</h3>
		<p class="account__section__desc">
			{{$t('account.select-network-you-are-using-with-your-betika-account')}}
		</p>
		<div class="divider"></div>
		<div :class="{
			'checkbox-container' : 1,
			'selected': selectedNetwork == netwrk.name
		}"
				 v-for="netwrk in availableNetworks"
				 :key="netwrk.name"
		>
			<b-checkbox
				:class="{
					'network' : 1
				}"
				:value="selectedNetwork == netwrk.name"
				:label="$options.filters.toTitleCase(netwrk.name)"
				:name="'network'"
				@click.native="selectedNetwork = netwrk.name"
				:disabled="loading"
			/>
		</div>
		<div class="divider"></div>
		<b-button
			class="button button__secondary account__section__submit full"
			:disabled="loading || !selectedNetwork"
			:loading="loading"
			:title="$t('account.set-network')"
			@click="saveNetwork"
			style="margin-bottom: 10px"
		>
		</b-button>
	</div>
</template>

<script>
import { getNetworkValue } from '../../../utils/networkProvider';

export default {
	name: "network-saver",
	props: {
		availableNetworks: {
			type: Array,
			required: true,
		},
		network: {
			type: String,
			required: false,
		},
		depositAmount: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			loading: false,
			error: false,
			selectedNetwork: null,
		};
	},
	mounted() {
		let vm = this;
		vm.selectedNetwork = vm.network;
	},
	methods: {
		saveNetwork(network) {
			let vm = this;
			vm.error = false;
			if (!this.selectedNetwork) return false;
			vm.loading = true;
			// Make http call
			let payload = {
				token: this.$auth.getToken(),
				network: getNetworkValue(this.selectedNetwork),
			};
			vm.$axios
				.post(`${BASE_URL}setnetwork`, payload)
				.then((res) => {
					vm.$notifications.add({
						message: res.data.message,
						type: "success",
						title: this.$t('account.network-update'),
						duration: 5000,
					});
					vm.loading = false;
					// Emit event to refresh user details in Account/Index
					vm.$emit("refreshUserDetails");
					vm.$emit("close");

					// Emit event to  perform the deposit in Session/Account/Deposit
					if(this.depositAmount != null){
						this.$root.$emit('perform-deposit', this.depositAmount);
					}
				})
				.catch((err) => {
					vm.error = err.response
						? err.response.data.error.message
						: err.message;
					vm.loading = false;
				});
		}
	},
};
</script>

<style lang="scss" scoped>
.divider{
	width:100%;
	height: 15px;
	background: var(--main-bg-color);
}
.checkbox{
	&-container{
		padding:5px;
		margin: 3px 0px;
		border-radius: 4px;

		&:hover{
			background-color: var(--line-11);
			cursor: pointer;
		}

		&.selected{
			background-color: var(--light-gray);
		}
	}
}
.network{
	cursor: pointer;
}
</style>
